var _style, _g, _g2, _defs, _g3, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _defs8, _defs9, _defs10, _defs11, _rect, _rect2, _rect3, _rect4, _g4, _defs12, _defs13, _defs14, _defs15, _defs16, _defs17, _defs18, _defs19, _rect5, _rect6, _rect7, _rect8, _defs20, _defs21, _defs22, _defs23, _defs24, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingSync(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 256.3 255.1",
    style: {
      enableBackground: "new 0 0 256.3 255.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#E0E0E0;}\n\t.st2{clip-path:url(#SVGID_2_);}\n\t.st3{fill:#EEF0F2;}\n\t.st4{fill:#E9EAEF;}\n\t.st5{fill:#E9EAEB;}\n\t.st6{clip-path:url(#SVGID_4_);}\n\t.st7{clip-path:url(#SVGID_6_);}\n\t.st8{clip-path:url(#SVGID_8_);}\n\t.st9{clip-path:url(#SVGID_18_);}\n\t.st10{clip-path:url(#SVGID_20_);}\n\t.st11{clip-path:url(#SVGID_22_);}\n\t.st12{fill:none;}\n\t.st13{clip-path:url(#SVGID_24_);}\n\t.st14{clip-path:url(#SVGID_26_);}\n\t.st15{clip-path:url(#SVGID_32_);}\n\t.st16{clip-path:url(#SVGID_34_);}\n\t.st17{clip-path:url(#SVGID_36_);}\n\t.st18{clip-path:url(#SVGID_38_);}\n\t.st19{clip-path:url(#SVGID_40_);}\n\t.st20{clip-path:url(#SVGID_42_);}\n\t.st21{clip-path:url(#SVGID_44_);}\n\t.st22{fill:none;stroke:#FD9926;stroke-dasharray:1,2;}\n\t.st23{fill:#FF9900;}\n\t.st24{fill:#FD9827;}\n\t.st25{fill:#333F4F;}\n\t.st26{fill:#333F50;}\n\t.st27{fill:#F4F6F7;}\n\t.st28{fill:#EDEDED;}\n\t.st29{fill:#8C8C8C;}\n")), /*#__PURE__*/React.createElement("g", {
    id: "Group_1870",
    transform: "translate(-313 -208)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1867",
    transform: "translate(6.454 0.402)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_42_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 434.2,
    cy: 333.1,
    rx: 122.4,
    ry: 122.4
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1866",
    transform: "matrix(0.985, -0.174, 0.174, 0.985, 351.769, 239.888)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1190"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M73.6,61.1c2.4-3.9,4-8.3,4.6-12.9l1.4,0.2l2.8,0.4h0c0.7-5,0.5-10.2-0.7-15.1l-4.1,1 c-1.1-4.5-3.1-8.7-5.9-12.4l3.4-2.5c-3-4.1-6.8-7.6-11.2-10.2l-2.2,3.7c-3.9-2.4-8.3-4-12.9-4.6l0.6-4.2 c-5-0.7-10.2-0.5-15.1,0.7l1,4.1c-4.5,1.1-8.7,3.1-12.4,5.9l-2.5-3.4c-4.1,3-7.6,6.8-10.2,11.2l3.7,2.2c-2.4,3.9-4,8.3-4.6,12.9 l-3-0.4l-1.2-0.2l0,0c-0.7,5-0.5,10.2,0.7,15.1l4.1-1C11,56,13,60.2,15.8,63.9l-3.4,2.5c3,4.1,6.8,7.6,11.2,10.2l2.2-3.7 c4,2.4,8.3,4,12.9,4.6l-0.5,3.3l-0.1,0.9c5,0.7,10.2,0.5,15.1-0.7l-1-4.1c4.5-1.1,8.7-3.1,12.4-5.9l2.5,3.4 c4.1-3,7.5-6.8,10.2-11.2L73.6,61.1z M34,59.3c-8.9-5.4-11.8-17-6.4-26c5.4-8.9,17-11.8,26-6.4c8.9,5.4,11.8,17,6.4,26 C54.6,61.8,42.9,64.7,34,59.3C34,59.3,34,59.3,34,59.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M37.5,82.2l0.6-4.2c-4.3-0.7-8.4-2.2-12.2-4.4l-2.2,3.7L23.3,77C18.9,74.4,15,70.9,12,66.7l-0.3-0.4 l3.4-2.6c-2.6-3.5-4.4-7.5-5.5-11.7l-4.1,1l-0.1-0.5c-1.2-5-1.5-10.2-0.7-15.3l0.1-0.7l0.6,0.3l3.6,0.5 c0.7-4.3,2.2-8.4,4.4-12.2l-3.7-2.2l0.3-0.4c2.7-4.4,6.1-8.3,10.3-11.3l0.4-0.3l2.6,3.4c3.5-2.6,7.5-4.4,11.7-5.5l-1-4.1 l0.5-0.1c5-1.2,10.2-1.5,15.3-0.7L50,4l-0.6,4.2c4.3,0.7,8.4,2.2,12.2,4.4l2.2-3.7l0.4,0.3c4.4,2.7,8.3,6.1,11.3,10.3l0.3,0.4 l-3.4,2.6C75,26,76.8,29.9,78,34.1l4.1-1l0.1,0.5c1.3,5,1.5,10.2,0.7,15.3l-0.1,0.4l-0.5,0l-3.7-0.5c-0.7,4.3-2.2,8.4-4.4,12.2 l3.7,2.2l-0.3,0.4C75,68,71.6,71.8,67.4,74.9L67,75.2l-2.6-3.4c-3.5,2.6-7.5,4.4-11.7,5.5l1,4.1l-0.5,0.1 c-5,1.3-10.2,1.5-15.3,0.7L37.5,82.2z M39.3,77.2l-0.6,4.2c4.7,0.6,9.3,0.4,13.9-0.7l-1-4.1l0.5-0.1c4.4-1.1,8.6-3.1,12.2-5.8 l0.4-0.3l2.5,3.4c3.7-2.9,6.9-6.3,9.4-10.3l-3.7-2.2l0.3-0.4c2.4-3.9,3.9-8.2,4.6-12.7l0.1-0.5l4.2,0.6 c0.6-4.7,0.4-9.4-0.7-13.9l-4.1,1l-0.1-0.5c-1.1-4.4-3-8.5-5.8-12.2L71,22.2l3.4-2.5c-2.8-3.8-6.3-6.9-10.3-9.4L61.9,14 l-0.4-0.3c-3.9-2.4-8.2-3.9-12.7-4.6l-0.5-0.1l0.6-4.2C44.2,4.2,39.6,4.4,35,5.5l1,4.1l-0.5,0.1c-4.4,1.1-8.5,3-12.2,5.8 l-0.4,0.3l-2.5-3.4c-3.8,2.9-6.9,6.3-9.4,10.3l3.7,2.2l-0.3,0.4c-2.4,3.9-3.9,8.2-4.6,12.7l-0.1,0.5L5.5,38 c-0.6,4.7-0.4,9.4,0.7,13.9l4.1-1l0.1,0.5c1.1,4.4,3,8.6,5.8,12.2l0.3,0.4l-3.4,2.5c2.8,3.8,6.3,6.9,10.3,9.4l2.2-3.7l0.4,0.3 c3.9,2.4,8.2,3.9,12.7,4.6L39.3,77.2z M40.4,62.2c-2.3-0.4-4.5-1.2-6.6-2.5l0,0l0,0c-4.4-2.7-7.6-6.9-8.8-12 c-1.2-5-0.5-10.2,2.2-14.7c2.7-4.4,6.9-7.6,12-8.8c5-1.2,10.2-0.5,14.7,2.2C62.9,32,65.9,44,60.4,53.1 C56.1,60.2,48,63.6,40.4,62.2z M34.2,58.9L34.2,58.9c8.7,5.3,20.1,2.4,25.3-6.3c5.2-8.7,2.4-20-6.3-25.3 c-4.2-2.5-9.2-3.3-13.9-2.1c-4.8,1.2-8.8,4.2-11.3,8.4c-2.5,4.2-3.3,9.2-2.1,13.9C27.1,52.3,30,56.3,34.2,58.9z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1856",
    transform: "translate(336.363 -3026.728)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1833_1_",
    transform: "translate(16.406 3282.887)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M156.5,78.8c0,41.8-33.9,75.6-75.6,75.6S5.3,120.5,5.3,78.8S39.1,3.1,80.9,3.1c0,0,0,0,0,0 C122.7,3.1,156.5,37,156.5,78.8"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1832_1_",
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1622_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M157.5,78.8c0,15.6-4.8,30.8-13.7,43.6c0,0.1-0.2,0.1-0.2,0.1l0,0c-14.2,20.6-37.7,32.8-62.8,32.7 c-2.1,0-4.2-0.1-6.3-0.4l0,0c0,0,0,0.1,0,0.1c-1-0.1-2-0.1-3.1-0.2c-0.4,0-0.7-0.1-1.1-0.1c-0.3,0-0.6-0.1-0.9-0.1 c-0.3,0-0.6-0.1-0.8-0.1c-0.1,0-0.1,0-0.2,0c-0.7-0.1-1.3-0.2-2-0.4h0c-41.6-8.1-68.8-48.5-60.7-90.1 c0.5-2.6,1.2-5.2,1.9-7.8C8,55,8.5,53.9,8.7,52.8l0,0c0.9-1.8,1.4-3.6,2.2-5.4c0.3-0.7,0.7-1.4,1-2.1c1.9-3.8,4-7.5,6.5-10.9 c0.2-0.3,0.5-0.6,0.7-0.9c0.9-1.2,1.9-2.4,2.8-3.6c1.5-1.8,3-3.5,4.6-5.1c4.2-4.2,8.9-8,14-11.1c1.6-1,3.2-1.9,4.9-2.8 c27-14,59.8-10.8,83.5,8.4c9.8,7.9,17.5,18,22.5,29.6c1.1,2.6,1.9,5.3,3,8l0,0c0,0-0.1,0-0.1,0 C156.5,64,157.5,71.4,157.5,78.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Union_7_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M66.7,153l-0.2,0l-0.1,0c0-0.2,0.1-0.5,0.2-0.7c0.9-6-7.4-10.1-8.8-14.3c-1-3-0.6-5.1-0.4-7.4 c0.2,0,0.4,0,0.5,0.1c0.3,0,0.6,0.1,0.9,0.1c0.9,0.1,1.8,0.3,2.6,0.4c0,0,0,0.1,0,0.1l0,0c1.8,0,3.6,0.1,5.4,0.1 c6.2,0,12.3-0.9,18.2-2.6c0.1,0.6-0.2,1.1-1.3,1.6c-2.7,1.3-3.8,4.6-6.6,9.3c-2.7,4.6-9.2,0.6-7.3,5.3s3.4,4.2,3.2,7.4 c0,0.6,0.2,1.1,0.5,1.6C71.3,153.8,69,153.5,66.7,153z M61.5,131.3L61.5,131.3C61.5,131.3,61.5,131.2,61.5,131.3 c-0.9-0.2-1.8-0.4-2.7-0.5c-0.3,0-0.6-0.1-0.9-0.1c-0.2,0-0.4,0-0.5-0.1c0.1-0.9,0.1-1.8,0-2.8c-0.3-3.5,0.8-8-1.2-10.9 s-10-3.9-11.5-9.7s2-14.6,3.4-16.1c1.4-1.5-6.6-8.3-10.4-8.5c-3.6-0.2-2.5-6.9-7.5-6.9c-0.4,0-0.8,0-1.3,0.1 c-0.9,0.1-1.8,0.2-2.7,0.2c-6.5,0-15.1-3.2-13-6.6c1.9-3.1,5.1-9.9-4.6-13.1c0.6-2.1,1.4-4.1,2.2-6.1l0.1-0.3 c0.5-1.1,0.9-2.2,1.5-3.3c0.1-0.1,0.1-0.2,0.2-0.4c2.6-5.4,5.8-10.6,9.6-15.3c0.3-0.3,0.6-0.7,0.8-1c1.7-2,3.4-3.8,5.3-5.6 c3.3-3.2,6.8-6,10.5-8.5c-0.4,1-0.7,2-0.7,3c0,0.4,0.1,0.9,0.4,1.2c0.2,0.1,0.4,0.2,0.6,0.2c0.5-0.1,1-0.2,1.5-0.4 c0.7-0.2,1.4-0.4,2.1-0.4c0.2,0,0.4,0,0.7,0c0,0,0.1,0,0.1,0c0.1,0,0.2,0,0.3,0.1c0.2,0.4,0.4,0.8,0.7,1.1 c2,2.7,5.6,3.6,8.7,3.8c-0.1,1.3,0.5,2.1,2.3,2.1c0.1,0,0.1,0,0.2,0c1.6,0,2.6-0.3,3.2-0.3c0.8,0,0.8,0.4,0.6,2 c-0.2,1.9,0,3.5,1.3,3.5c1-0.1,1.9-0.6,2.6-1.2c2.8-2.2,2.8-4.3,4.2-4.3c0.4,0,0.8,0.1,1.2,0.3c0.6,0.3,1.2,0.5,1.9,0.5 c1.2,0,1.9-0.9,3.8-2.3c2,2.4,3.8,5,5.2,7.8l0,0c-1,0.2-2,0.3-3,0.3c-0.4,0-0.8,0-1.1,0c-0.7,0-1.3,0-1.8-0.1s-1-0.1-1.3-0.1 c-1.4,0-2,0.4-3,3c-1.1,2.3-2.6,4.3-4.6,5.9c-2.4-1-5-1.6-7.6-1.6c-9.5,0-17.6,7-19,16.4c-0.5-0.2-1.1-0.4-1.6-0.4 c-1.1,0-2.2,0.5-2.9,1.4c-4.3,4.2-11.7,11.6-3.5,13c0.6,0.1,1.2,0.2,1.8,0.2c2.6,0,3.3-1.3,3.7-2.6s0.4-2.6,1.6-2.6 c0.3,0,0.6,0.1,0.9,0.2c4.1,1.5-2.6,4.9,0.1,6.1s3.9,0.7,3.9,4.4c0,3.1,0.6,6.2,2.8,6.2c0.5,0,1-0.1,1.5-0.4 c0.7-0.4,1.4-0.8,2-1.3c2.3,3.2,4.5,6,6.2,8c0,0,0,0,0,0l0,0l0,0l0,0c0.6,0.7,1.5,1.1,2.5,1.1c1,0,1.9-0.4,2.5-1.2 c1.8-2.2,4.3-5.4,6.9-9c0.1,0,0.3-0.1,0.5-0.1c2,0,3.3,3,4.2,4.5c1,1.7,5.1,0,8.4,5.1c2.3,3.6,3.6,5.1,5.5,5.1 c1-0.1,2-0.4,2.9-0.9c0.9-0.5,1.9-0.8,3-0.9c1.7,0,2.6,1.2,3.3,3c1,2.6,3.3,0.1,4.4,3.5s0.6,2.9-1.1,5.2 c-1,1.4-3.2,3-4.1,5.4l-0.4,0h0c-0.8,0-2.1,0.8-2,1.5c0,0.2-0.1,0.4,0,0.5l1.7,10.1c-0.3,0-0.7,0-1-0.1 c-1.2-0.2-2.3-0.3-3.5-0.3c-2.8,0-5.8,0.6-5,2.8c0.7,2,1.8,3.3,1.9,4.2c-5.9,1.7-12,2.6-18.2,2.6 C65.1,131.4,63.3,131.3,61.5,131.3L61.5,131.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1624_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M114.8,44.9c-1.9,0.1-3.6-1.1-4.3-2.8c-1.9-4.1,4.2-4.9,8.8-4.9c1.4,0,2.8,0.1,4.2,0.3 c0.1,0,0.2,0,0.3,0c1-0.1,2-0.4,2.9-1c0.4,0.9,0.9,1.8,1.3,2.8c0.2,0.4,0.4,0.9,0.6,1.3c-1.8,0.3-3.6,0.8-5.3,1.5 C121.2,42.9,117.7,44.9,114.8,44.9"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1625_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M120.4,85.8c-2.9-0.1-5.7-1.1-8.1-2.8c-10.8-7.1-4.7-19-0.6-19.1c4.1-0.1,8.9-2.1,5.5-7.1 c-2.5-3.7-0.3-5,2.1-5c0.8,0,1.6,0.2,2.4,0.5c0.4,0.2,0.8,0.3,1.3,0.2c2.2,0,5.1-1.6,8.3-2.8c2.7,11.4,2.4,23.2-0.9,34.4 c-0.1-0.1-0.2-0.2-0.3-0.3c-0.3-0.3-0.8-0.5-1.3-0.5c-1.2,0.2-2.3,0.6-3.3,1.2C123.9,85.4,122.2,85.8,120.4,85.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1626_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M123.3,32.7c-1.6,0-1.5-1-1.1-2.7c0.1-0.4,0.1-0.7,0-1.1c0.8,1.2,1.5,2.4,2.2,3.7 c-0.1,0-0.1,0.1-0.1,0.1C124,32.6,123.7,32.7,123.3,32.7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1627_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M119.5,31.8c-0.8-0.1-1.6-0.6-2.1-1.3c-2.1-2.6,1.5-4.1,1.5-4.1l0,0h0.1c2.4,0,1.9,3.1,2,3.9 C121,31.1,120.3,31.7,119.5,31.8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1630_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.6,49.9c-1,0-1.8-0.7-2-2.2c-0.2-2.7-2.2-5.4-6.1-6.7c-1.2-0.4-2.4-0.6-3.6-0.6c-0.5,0-1,0-1.6,0.1 c-0.2-0.4-0.4-0.9-0.6-1.3c-0.4-0.9-0.8-1.9-1.3-2.8c2.4-1.3,4.9-3.7,5.4-5c0.2-0.9,1-1.4,1.9-1.3c0.4,0,0.9,0,1.6,0.1 s1.4,0.1,2.3,0.1h0.4c0.4,0,0.7,0,0.9,0c1.5,1.8,2.9,3.6,4.2,5.6c2.7,4,5.1,8.2,7,12.6c-2.3-1-3-6.5-4.4-7.6 c-0.1-0.1-0.2-0.2-0.4-0.2c-0.8,0,0.5,4,0.8,5.8c0.4,2-0.8,0.3-2.3,2.1C143.5,49.4,142.6,49.9,141.6,49.9 M138,29.2 c-1.1-0.4-2.5-0.8-4.1-1.3c-4.6-1.5-0.7-1.7-4.9-5c-1.4-1.2-1.4-2.2-0.7-3C131.8,22.7,135.1,25.8,138,29.2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1631_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M150.1,106.3c-0.2-3.3-0.2-6.5-0.2-9.7c-3.4-1.2-6.9-1.8-10.5-2.1c-0.9-2-1.2-3.8-0.5-5.1 c1.5-2.8,1.1-3.1-1.5-3.1h-0.3c-0.4,0-0.7,0-1,0c-2.1,0.2-4.2-0.6-5.7-2.1c3.3-11.2,3.7-23.1,0.9-34.4 c0.7-0.3,1.4-0.5,2.1-0.7c0.3-0.1,0.7-0.2,1-0.2c3.6,0,3.6,6.5,5.9,7.8c0.9,0.5,1.9,0.7,2.9,0.7c2.6,0,5.1-1,7.1-2.8 c0.3-0.4,0.7-0.6,1.2-0.7c0.4,0,0.7,0.3,1.1,0.7c0.7,2,1.2,4,1.7,6c0,0.1,0.1,0.3,0.1,0.4c1.2,4.9,1.8,9.8,2,14.8 c0,0.1,0,0.2,0,0.3c0,0.9,0,1.7,0,2.6c0,8.7-1.5,17.4-4.4,25.6c-0.2,0.6-0.4,1.1-0.6,1.7C151,106.1,150.6,106.2,150.1,106.3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1632_1_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M124.5,32.5c-0.7-1.2-1.5-2.5-2.2-3.7c-0.2-2.3-1.5-5.9-0.3-7.9c0.2-0.3,0.4-0.5,0.6-0.5 c1.3,0,2.9,5.9,4,8.1C127.6,30.8,125.1,32.2,124.5,32.5"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1837",
    transform: "translate(80.894 3299.748)"
  }, /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_3_",
    d: "M6.8,4.5c-0.5-0.5-1-1-1.5-1.4l0,0C5.8,3.6,6.3,4,6.8,4.5L6.8,4.5"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1836",
    className: "st6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1835",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 5.3,
    y: 3.1,
    width: 1.5,
    height: 1.4
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1834",
    className: "st7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_427"
  }, /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 5.2,
    y: 3.1,
    width: 1.8,
    height: 1.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", null, _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_9_",
    x: 6,
    y: 2.5,
    width: 1.8,
    height: 1.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_10_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_9_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_10_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 48,
    height: 42,
    xlinkHref: "3A3C79BA4E23958C.jpg",
    transform: "matrix(3.704167e-02 0 0 -3.704762e-02 6.0352 4.2142)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", null, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_11_",
    x: 6,
    y: 4.3,
    width: 1.8,
    height: 1.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_12_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_11_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_12_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 48,
    height: 42,
    xlinkHref: "3A3C79BA4E23958D.jpg",
    transform: "matrix(3.704167e-02 0 0 -3.704762e-02 6.0352 5.9922)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", null, _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_13_",
    x: 4.3,
    y: 2.5,
    width: 1.8,
    height: 1.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_14_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_13_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_14_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 48,
    height: 42,
    xlinkHref: "3A3C79BA4E239582.jpg",
    transform: "matrix(3.704167e-02 0 0 -3.704762e-02 4.2572 4.2142)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st8"
  }, /*#__PURE__*/React.createElement("g", null, _defs8 || (_defs8 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_15_",
    x: 4.3,
    y: 4.3,
    width: 1.8,
    height: 1.8
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_16_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_15_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_16_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 48,
    height: 42,
    xlinkHref: "3A3C79BA4E239583.jpg",
    transform: "matrix(3.704167e-02 0 0 -3.704762e-02 4.2572 5.9922)"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1841",
    transform: "translate(55.685 3287.623)"
  }, /*#__PURE__*/React.createElement("g", null, _defs9 || (_defs9 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_17_",
    d: "M5.3,3.3L5.3,3.3L5.3,3.3 M5.3,3.3L5.3,3.3L5.3,3.3 M5.3,3.2L5.3,3.2L5.3,3.2 M5.3,3.2L5.3,3.2  M5.3,3.2L5.3,3.2 M5.3,3.2L5.3,3.2 M5.3,3.2L5.3,3.2 M5.4,3.1L5.4,3.1 M5.4,3.1L5.4,3.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_18_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_17_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1840",
    transform: "translate(0 0)",
    className: "st9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1839",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs10 || (_defs10 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_19_",
    x: 5.3,
    y: 3.1,
    width: 0.1,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_20_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_19_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1838",
    className: "st10"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_429"
  }, /*#__PURE__*/React.createElement("g", null, _defs11 || (_defs11 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_21_",
    x: 5.2,
    y: 3.1,
    width: 0.3,
    height: 0.3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_22_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_21_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.4,
    y: 2.9,
    className: "st12",
    width: 0.3,
    height: 0.3
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 8,
    height: 9,
    xlinkHref: "3A3C79BA4E239584.jpg",
    transform: "matrix(3.700000e-02 0 0 -3.700000e-02 5.4135 3.2542)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.4,
    y: 3.3,
    className: "st12",
    width: 0.3,
    height: 0.3
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 8,
    height: 9,
    xlinkHref: "3A3C79BA4E239587.jpg",
    transform: "matrix(3.700000e-02 0 0 -3.700000e-02 5.4135 3.5872)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.1,
    y: 2.9,
    className: "st12",
    width: 0.3,
    height: 0.3
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 8,
    height: 9,
    xlinkHref: "3A3C79BA4E239586.jpg",
    transform: "matrix(3.700000e-02 0 0 -3.700000e-02 5.0805 3.2542)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st11"
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5.1,
    y: 3.3,
    className: "st12",
    width: 0.3,
    height: 0.3
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 8,
    height: 9,
    xlinkHref: "3A3C79BA4E239581.jpg",
    transform: "matrix(3.700000e-02 0 0 -3.700000e-02 5.0805 3.5872)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1845",
    transform: "translate(161.267 3385.795)"
  }, /*#__PURE__*/React.createElement("g", null, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M5.4,6"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1844",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1843",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs12 || (_defs12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_23_",
    x: 5.3,
    y: 3.1,
    width: 1.3,
    height: 2.9
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_24_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_23_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1842",
    className: "st13"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_431"
  }, /*#__PURE__*/React.createElement("g", null, _defs13 || (_defs13 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_25_",
    x: 5.2,
    y: 3.1,
    width: 1.6,
    height: 3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_26_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_25_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", null, _defs14 || (_defs14 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_27_",
    x: 4.3,
    y: 2.1,
    width: 3,
    height: 3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_28_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_27_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_28_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 44,
    height: 82,
    xlinkHref: "3A3C79BA4E239599.jpg",
    transform: "matrix(3.704545e-02 0 0 -3.704878e-02 5.0424 5.1355)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st14"
  }, /*#__PURE__*/React.createElement("g", null, _defs15 || (_defs15 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_29_",
    x: 4.3,
    y: 5.1,
    width: 3,
    height: 3
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_30_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_29_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_30_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 44,
    height: 82,
    xlinkHref: "6ABD97ED4B249CD2.jpg",
    transform: "matrix(3.704545e-02 0 0 -3.704878e-02 5.0424 8.1735)"
  })))))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1847",
    transform: "translate(105.776 3413.02)"
  }, /*#__PURE__*/React.createElement("g", null, _defs16 || (_defs16 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_31_",
    d: "M16,4.6L6.4,4.1c-0.6,0-1.1-0.5-1.2-1l0,0c0.1,0.6,0.6,1,1.2,1L16,4.6L16,4.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_32_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_31_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1846",
    transform: "translate(0 0)",
    className: "st15"
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 292,
    height: 42,
    id: "Rectangle_433",
    xlinkHref: "6ABD97ED4B249CD5.jpg",
    transform: "matrix(3.711905e-02 0 0 3.711905e-02 5.1976 3.065)"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1851",
    transform: "translate(65.709 3368.75)"
  }, /*#__PURE__*/React.createElement("g", null, _defs17 || (_defs17 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_33_",
    d: "M5.3,3.2L5.3,3.2L5.3,3.2 M5.3,3.2L5.3,3.2L5.3,3.2"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_34_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_33_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1850",
    className: "st16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1849",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs18 || (_defs18 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_35_",
    x: 5.3,
    y: 3.1,
    width: 0,
    height: 0
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_36_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_35_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1848",
    className: "st17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_434"
  }, /*#__PURE__*/React.createElement("g", null, _defs19 || (_defs19 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_37_",
    x: 5.2,
    y: 3.1,
    width: 0.3,
    height: 0.2
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_38_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_37_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 5.2,
    y: 2.8,
    className: "st12",
    width: 0.3,
    height: 0.3
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 8,
    height: 6,
    xlinkHref: "6ABD97ED4B249CD6.jpg",
    transform: "matrix(3.700000e-02 0 0 -3.700000e-02 5.201 3.0593)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 5.2,
    y: 3.1,
    className: "st12",
    width: 0.3,
    height: 0.3
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 8,
    height: 6,
    xlinkHref: "6ABD97ED4B249CD4.jpg",
    transform: "matrix(3.700000e-02 0 0 -3.700000e-02 5.201 3.3553)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 4.9,
    y: 2.8,
    className: "st12",
    width: 0.3,
    height: 0.3
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 8,
    height: 6,
    xlinkHref: "6ABD97ED4B249CD3.jpg",
    transform: "matrix(3.700000e-02 0 0 -3.700000e-02 4.905 3.0593)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st18"
  }, _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 4.9,
    y: 3.1,
    className: "st12",
    width: 0.3,
    height: 0.3
  })), /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 8,
    height: 6,
    xlinkHref: "6ABD97ED4B249CCD.jpg",
    transform: "matrix(3.700000e-02 0 0 -3.700000e-02 4.905 3.3553)"
  })))))))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1855",
    transform: "translate(49.022 3336.755)"
  }, /*#__PURE__*/React.createElement("g", null, _defs20 || (_defs20 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_39_",
    d: "M5.3,5.6L5.3,5.6 M5.3,5.6C5.3,5.6,5.3,5.6,5.3,5.6C5.3,5.5,5.3,5.6,5.3,5.6 M5.3,5.5L5.3,5.5  M5.3,5.5L5.3,5.5 M5.3,5.5L5.3,5.5 M5.3,5.4L5.3,5.4 M5.3,5.4L5.3,5.4 M5.3,5.4L5.3,5.4 M5.3,5.4C5.3,5.4,5.3,5.3,5.3,5.4 C5.3,5.3,5.3,5.4,5.3,5.4 M5.3,5.3C5.3,5.3,5.3,5.3,5.3,5.3C5.3,5.3,5.3,5.3,5.3,5.3 M5.3,5.3L5.3,5.3 M5.3,5.3 C5.3,5.3,5.3,5.2,5.3,5.3C5.3,5.2,5.3,5.3,5.3,5.3 M5.3,5.2C5.3,5.2,5.3,5.2,5.3,5.2C5.3,5.2,5.3,5.2,5.3,5.2 M5.3,5.2 L5.3,5.2 M5.3,5.2L5.3,5.2 M5.3,5.1L5.3,5.1 M5.3,5.1L5.3,5.1 M5.3,5.1L5.3,5.1 M5.3,5.1C5.3,5,5.3,5,5.3,5.1 C5.3,5,5.3,5,5.3,5.1 M5.3,5C5.3,5,5.3,5,5.3,5C5.3,5,5.3,5,5.3,5 M5.3,5C5.3,5,5.3,5,5.3,5C5.3,5,5.3,5,5.3,5 M5.3,4.9 C5.3,4.9,5.3,4.9,5.3,4.9C5.3,4.9,5.3,4.9,5.3,4.9 M5.3,4.9C5.3,4.9,5.3,4.9,5.3,4.9C5.3,4.9,5.3,4.9,5.3,4.9 M5.3,4.9 L5.3,4.9 M5.3,4.9C5.3,4.9,5.3,4.9,5.3,4.9C5.3,4.9,5.3,4.9,5.3,4.9 M5.3,4.8C5.3,4.8,5.3,4.8,5.3,4.8 C5.3,4.8,5.3,4.8,5.3,4.8 M5.3,4.8C5.3,4.8,5.3,4.8,5.3,4.8C5.3,4.8,5.3,4.8,5.3,4.8 M5.3,4.8C5.3,4.8,5.3,4.8,5.3,4.8 C5.3,4.8,5.3,4.8,5.3,4.8 M5.3,4.7C5.3,4.7,5.3,4.7,5.3,4.7C5.3,4.7,5.3,4.7,5.3,4.7 M5.3,4.7C5.3,4.7,5.3,4.7,5.3,4.7 C5.3,4.7,5.3,4.7,5.3,4.7 M5.3,4.7L5.3,4.7 M5.3,4.6C5.3,4.6,5.3,4.6,5.3,4.6C5.3,4.6,5.3,4.6,5.3,4.6 M5.3,4.6 C5.3,4.6,5.3,4.6,5.3,4.6C5.3,4.6,5.3,4.6,5.3,4.6 M5.3,4.6C5.3,4.6,5.3,4.6,5.3,4.6C5.3,4.6,5.3,4.6,5.3,4.6 M5.3,4.6 C5.3,4.6,5.3,4.5,5.3,4.6C5.3,4.5,5.3,4.6,5.3,4.6 M5.3,4.5C5.3,4.5,5.3,4.5,5.3,4.5C5.3,4.5,5.3,4.5,5.3,4.5 M5.3,4.5 C5.3,4.5,5.3,4.5,5.3,4.5C5.3,4.5,5.3,4.5,5.3,4.5 M5.3,4.5C5.3,4.5,5.3,4.5,5.3,4.5C5.3,4.4,5.3,4.5,5.3,4.5 M5.3,4.4 C5.3,4.4,5.3,4.4,5.3,4.4C5.3,4.4,5.3,4.4,5.3,4.4 M5.3,4.4C5.3,4.4,5.3,4.4,5.3,4.4C5.3,4.4,5.3,4.4,5.3,4.4 M5.3,4.4 C5.3,4.4,5.3,4.4,5.3,4.4C5.3,4.3,5.3,4.4,5.3,4.4 M5.3,4.3C5.3,4.3,5.3,4.3,5.3,4.3C5.3,4.3,5.3,4.3,5.3,4.3 M5.3,4.3 C5.3,4.3,5.3,4.3,5.3,4.3C5.3,4.3,5.3,4.3,5.3,4.3 M5.3,4.3C5.3,4.3,5.3,4.3,5.3,4.3C5.3,4.3,5.3,4.3,5.3,4.3 M5.3,4.3 C5.3,4.3,5.3,4.2,5.3,4.3C5.3,4.2,5.3,4.2,5.3,4.3 M5.3,4.2C5.3,4.2,5.3,4.2,5.3,4.2C5.3,4.2,5.3,4.2,5.3,4.2 M5.3,4.2 C5.3,4.2,5.3,4.2,5.3,4.2C5.3,4.2,5.3,4.2,5.3,4.2 M5.3,4.1C5.3,4.1,5.3,4.1,5.3,4.1C5.3,4.1,5.3,4.1,5.3,4.1 M5.3,4.1 C5.3,4.1,5.3,4.1,5.3,4.1C5.3,4.1,5.3,4.1,5.3,4.1 M5.3,4.1C5.3,4.1,5.3,4.1,5.3,4.1C5.3,4.1,5.3,4.1,5.3,4.1 M5.3,4.1 C5.3,4.1,5.3,4.1,5.3,4.1C5.3,4.1,5.3,4.1,5.3,4.1 M5.3,4C5.3,4,5.3,4,5.3,4C5.3,4,5.3,4,5.3,4 M5.3,4C5.3,4,5.3,4,5.3,4 C5.3,4,5.3,4,5.3,4 M5.3,4C5.3,4,5.3,4,5.3,4C5.3,4,5.3,4,5.3,4 M5.3,3.9C5.3,3.9,5.3,3.9,5.3,3.9C5.3,3.9,5.3,3.9,5.3,3.9  M5.3,3.9C5.3,3.9,5.3,3.9,5.3,3.9C5.3,3.9,5.3,3.9,5.3,3.9 M5.3,3.8C5.3,3.8,5.3,3.8,5.3,3.8C5.3,3.8,5.3,3.8,5.3,3.8  M5.3,3.8C5.3,3.8,5.3,3.8,5.3,3.8C5.3,3.8,5.3,3.8,5.3,3.8 M5.3,3.8C5.3,3.8,5.3,3.8,5.3,3.8C5.3,3.7,5.3,3.8,5.3,3.8  M5.3,3.7C5.3,3.7,5.3,3.7,5.3,3.7C5.3,3.7,5.3,3.7,5.3,3.7 M5.3,3.7C5.3,3.7,5.3,3.7,5.3,3.7C5.3,3.7,5.3,3.7,5.3,3.7  M5.3,3.7C5.3,3.7,5.3,3.7,5.3,3.7C5.3,3.7,5.3,3.7,5.3,3.7 M5.3,3.6C5.3,3.6,5.3,3.6,5.3,3.6C5.3,3.6,5.3,3.6,5.3,3.6  M5.3,3.5L5.3,3.5 M5.3,3.5L5.3,3.5 M5.3,3.5C5.3,3.5,5.3,3.5,5.3,3.5C5.3,3.5,5.3,3.5,5.3,3.5 M5.3,3.5L5.3,3.5 M5.3,3.4 L5.3,3.4 M5.3,3.4L5.3,3.4 M5.3,3.4L5.3,3.4 M5.3,3.2L5.3,3.2 M5.3,3.2L5.3,3.2 M5.3,3.2L5.3,3.2 M5.3,3.2L5.3,3.2L5.3,3.2  M5.3,3.1L5.3,3.1"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_40_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_39_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1854",
    className: "st19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1853",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", null, _defs21 || (_defs21 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_41_",
    x: 5.3,
    y: 3.1,
    width: 0.2,
    height: 2.5
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_42_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_41_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1852",
    className: "st20"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_436"
  }, /*#__PURE__*/React.createElement("g", null, _defs22 || (_defs22 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_43_",
    x: 5.2,
    y: 3.1,
    width: 0.4,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_44_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_43_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("g", null, _defs23 || (_defs23 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_45_",
    x: 5.2,
    y: 0.6,
    width: 2.6,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_46_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_45_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_46_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 12,
    height: 71,
    xlinkHref: "6ABD97ED4B249CCE.jpg",
    transform: "matrix(3.708333e-02 0 0 -3.704226e-02 6.253 3.2275)"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st21"
  }, /*#__PURE__*/React.createElement("g", null, _defs24 || (_defs24 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_47_",
    x: 5.2,
    y: 3.2,
    width: 2.6,
    height: 2.6
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_48_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_47_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_48_)",
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible"
    },
    width: 12,
    height: 71,
    xlinkHref: "6ABD97ED4B249CCC.jpg",
    transform: "matrix(3.708333e-02 0 0 -3.704226e-02 6.253 5.8575)"
  }))))))))))))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_53",
    transform: "translate(352.769 256.159)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st12",
    cx: 81.4,
    cy: 78.8,
    rx: 76.1,
    ry: 75.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M81.4,154.4c-42,0-76.1-33.9-76.1-75.6S39.4,3.1,81.4,3.1s76.1,33.9,76.1,75.6S123.4,154.4,81.4,154.4z  M81.4,4.1C40,4.1,6.3,37.6,6.3,78.8s33.7,74.6,75.1,74.6s75.1-33.5,75.1-74.6S122.8,4.1,81.4,4.1z"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Path_1644"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M509.3,333.1"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_440"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M365.2,299h0.2c1.2,0,2.2,1,2.2,2.2l0,0c0,1.2-1,2.2-2.2,2.2h-0.2c-1.2,0-2.2-1-2.2-2.2l0,0 C363,300,364,299,365.2,299z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_443"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M511.5,342.6h0.2c1.2,0,2.2,1,2.2,2.2l0,0c0,1.2-1,2.2-2.2,2.2h-0.2c-1.2,0-2.2-1-2.2-2.2l0,0 C509.3,343.5,510.3,342.6,511.5,342.6z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1864",
    transform: "translate(-1923.438 -166.656)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1650"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M2361.6,545.1l0-1l1,0l0,1L2361.6,545.1z M2359.6,545.1c-0.3,0-0.7,0-1,0l0-1c0.3,0,0.7,0,1,0 L2359.6,545.1z M2364.6,545l0-1l1,0l0,1L2364.6,545z M2356.6,545l-1,0l0-1l1,0L2356.6,545z M2367.6,544.9l-0.1-1l1-0.1l0.1,1 L2367.6,544.9z M2353.6,544.8l-1-0.1l0.1-1l1,0.1L2353.6,544.8z M2370.6,544.7l-0.1-1l1-0.1l0.1,1L2370.6,544.7z M2350.6,544.6 c-0.3,0-0.7-0.1-1-0.1l0.1-1c0.3,0,0.7,0.1,1,0.1L2350.6,544.6z M2373.6,544.4l-0.1-1l1-0.1l0.1,1L2373.6,544.4z M2347.6,544.2 c-0.3-0.1-0.7-0.1-1-0.2l0.2-1c0.3,0.1,0.7,0.1,1,0.2L2347.6,544.2z M2376.6,544.1l-0.1-1l1-0.1l0.1,1L2376.6,544.1z  M2344.6,543.7c-0.3-0.1-0.7-0.1-1-0.2l0.2-1c0.3,0.1,0.7,0.1,1,0.2L2344.6,543.7z M2379.6,543.7l-0.1-1l1-0.1l0.2,1 L2379.6,543.7z M2382.6,543.2l-0.2-1l1-0.2l0.2,1L2382.6,543.2z M2341.6,543c-0.3-0.1-0.7-0.2-1-0.2l0.2-1 c0.3,0.1,0.6,0.2,1,0.2L2341.6,543z M2385.5,542.6l-0.2-1l1-0.2l0.2,1L2385.5,542.6z M2338.7,542.3l-1-0.3l0.3-1l1,0.3 L2338.7,542.3z M2388.5,542l-0.2-1l1-0.2l0.2,1L2388.5,542z M2335.8,541.5l-1-0.3l0.3-1l1,0.3L2335.8,541.5z M2391.4,541.3 l-0.2-1l1-0.2l0.2,1C2392.1,541.2,2391.8,541.2,2391.4,541.3z M2332.9,540.6l-1-0.3l0.3-1l0.9,0.3L2332.9,540.6z M2394.4,540.6 l-0.3-1l1-0.3l0.3,1L2394.4,540.6z M2397.3,539.7l-0.3-1l1-0.3l0.3,1L2397.3,539.7z M2330.1,539.7l-0.9-0.3l0.3-0.9l0.9,0.3 L2330.1,539.7z M2400.1,538.8l-0.3-0.9c0.3-0.1,0.6-0.2,0.9-0.3l0.3,0.9C2400.8,538.6,2400.4,538.7,2400.1,538.8z M2327.2,538.7 l-0.9-0.3l0.3-0.9l0.9,0.3L2327.2,538.7z M2403,537.8l-0.3-0.9l0.9-0.4l0.4,0.9L2403,537.8z M2324.4,537.6l-0.9-0.4l0.4-0.9 l0.9,0.4L2324.4,537.6z M2405.8,536.7l-0.4-0.9c0.3-0.1,0.6-0.3,0.9-0.4l0.4,0.9C2406.4,536.4,2406.1,536.6,2405.8,536.7z  M2321.6,536.5l-0.9-0.4l0.4-0.9l0.9,0.4L2321.6,536.5z M2408.5,535.5l-0.4-0.9c0.3-0.1,0.6-0.3,0.9-0.4l0.4,0.9 C2409.2,535.2,2408.9,535.4,2408.5,535.5z M2318.8,535.3l-0.9-0.4l0.4-0.9l0.9,0.4L2318.8,535.3z M2411.3,534.2l-0.4-0.9 c0.3-0.1,0.6-0.3,0.9-0.4l0.5,0.9C2411.9,533.9,2411.6,534.1,2411.3,534.2z M2316.1,534.1l-0.9-0.4l0.4-0.9l0.9,0.4 L2316.1,534.1z M2414,532.8l-0.5-0.9c0.3-0.2,0.6-0.3,0.9-0.5l0.5,0.9C2414.5,532.5,2414.3,532.6,2414,532.8z M2313.4,532.8 l-0.9-0.4l0.4-0.9l0.9,0.4L2313.4,532.8z M2310.7,531.4l-0.9-0.5l0.5-0.9l0.9,0.5L2310.7,531.4z M2416.6,531.3l-0.5-0.9 c0.3-0.2,0.6-0.3,0.8-0.5l0.5,0.8C2417.2,531,2416.9,531.1,2416.6,531.3z M2308,530l-0.9-0.5l0.5-0.9l0.9,0.5L2308,530z  M2419.1,529.7l-0.6-0.8c0.3-0.2,0.5-0.4,0.8-0.6l0.6,0.8C2419.7,529.3,2419.4,529.5,2419.1,529.7z M2305.4,528.6l-0.9-0.5 l0.5-0.9l0.9,0.5L2305.4,528.6z M2421.6,527.9l-0.6-0.8c0.3-0.2,0.5-0.4,0.8-0.6l0.6,0.8 C2422.1,527.5,2421.9,527.7,2421.6,527.9z M2302.8,527l-0.9-0.5l0.5-0.9l0.9,0.5L2302.8,527z M2424,526l-0.6-0.8 c0.3-0.2,0.5-0.4,0.8-0.6l0.7,0.8C2424.5,525.6,2424.2,525.8,2424,526z M2300.2,525.5c-0.3-0.2-0.6-0.4-0.8-0.5l0.5-0.8 c0.3,0.2,0.6,0.4,0.8,0.5L2300.2,525.5z M2426.2,524l-0.7-0.7c0.2-0.2,0.5-0.5,0.7-0.7l0.7,0.7 C2426.7,523.6,2426.5,523.8,2426.2,524z M2297.7,523.8l-0.8-0.6l0.6-0.8l0.8,0.6L2297.7,523.8z M2295.2,522.1 c-0.3-0.2-0.5-0.4-0.8-0.6l0.6-0.8c0.3,0.2,0.5,0.4,0.8,0.6L2295.2,522.1z M2428.3,521.9l-0.7-0.7c0.2-0.2,0.4-0.5,0.7-0.7 l0.8,0.7C2428.8,521.4,2428.6,521.6,2428.3,521.9z M2292.8,520.2c-0.3-0.2-0.5-0.4-0.8-0.6l0.6-0.8c0.3,0.2,0.5,0.4,0.8,0.6 L2292.8,520.2z M2430.3,519.5l-0.8-0.6c0.2-0.3,0.4-0.5,0.6-0.8l0.8,0.6C2430.7,519,2430.5,519.3,2430.3,519.5z M2290.5,518.3 c-0.3-0.2-0.5-0.4-0.8-0.7l0.7-0.8c0.2,0.2,0.5,0.4,0.8,0.6L2290.5,518.3z M2432.1,517.1l-0.8-0.6c0.2-0.3,0.4-0.6,0.5-0.8 l0.8,0.5C2432.5,516.5,2432.3,516.8,2432.1,517.1z M2288.2,516.3c-0.2-0.2-0.5-0.5-0.7-0.7l0.7-0.7c0.2,0.2,0.5,0.5,0.7,0.7 L2288.2,516.3z M2433.7,514.5l-0.9-0.5c0.2-0.3,0.3-0.6,0.5-0.9l0.9,0.4C2434,513.9,2433.8,514.2,2433.7,514.5z M2286,514.2 c-0.2-0.2-0.5-0.5-0.7-0.7l0.7-0.7c0.2,0.2,0.5,0.5,0.7,0.7L2286,514.2z M2284,512c-0.2-0.3-0.4-0.5-0.7-0.8l0.8-0.6 c0.2,0.3,0.4,0.5,0.6,0.8L2284,512z M2435,511.7l-0.9-0.4c0.1-0.3,0.3-0.6,0.4-0.9l0.9,0.4 C2435.2,511.1,2435.1,511.4,2435,511.7z M2282.1,509.6c-0.2-0.3-0.4-0.5-0.6-0.8l0.8-0.6c0.2,0.3,0.4,0.5,0.6,0.8L2282.1,509.6z  M2436.1,508.9l-1-0.3c0.1-0.3,0.2-0.6,0.3-0.9l1,0.3C2436.3,508.2,2436.2,508.6,2436.1,508.9z M2280.3,507.1 c-0.2-0.3-0.4-0.6-0.5-0.9l0.9-0.5c0.2,0.3,0.3,0.6,0.5,0.8L2280.3,507.1z M2436.9,506l-1-0.2c0.1-0.3,0.1-0.6,0.2-1l1,0.2 C2437,505.3,2436.9,505.6,2436.9,506z M2278.9,504.5c-0.2-0.3-0.3-0.6-0.4-0.9l0.9-0.4c0.1,0.3,0.3,0.6,0.4,0.9L2278.9,504.5z  M2437.4,503l-1-0.1c0-0.3,0.1-0.7,0.1-1l1,0.1C2437.5,502.3,2437.4,502.6,2437.4,503z M2277.7,501.6c-0.1-0.3-0.2-0.6-0.3-1 l1-0.3c0.1,0.3,0.2,0.6,0.3,0.9L2277.7,501.6z M2437.7,499.9l-1,0c0-0.3,0-0.7,0-1l1,0C2437.7,499.2,2437.7,499.6,2437.7,499.9z  M2276.9,498.7c-0.1-0.3-0.1-0.7-0.2-1l1-0.1c0,0.3,0.1,0.6,0.2,1L2276.9,498.7z M2436.7,496.9c0-0.3,0-0.7,0-1l1-0.1 c0,0.3,0,0.7,0.1,1L2436.7,496.9z M2276.5,495.6c0-0.3,0-0.7,0-1l1,0c0,0.3,0,0.6,0,1L2276.5,495.6z M2436.5,494 c0-0.3-0.1-0.7-0.1-1l1-0.1c0,0.3,0.1,0.7,0.1,1L2436.5,494z M2277.6,492.7l-1-0.1c0-0.3,0.1-0.7,0.1-1l1,0.1 C2277.7,492,2277.6,492.3,2277.6,492.7z M2436,491c-0.1-0.3-0.1-0.6-0.2-1l1-0.2c0.1,0.3,0.1,0.7,0.2,1L2436,491z M2278,489.8 l-1-0.2c0.1-0.3,0.2-0.7,0.3-1l1,0.3C2278.2,489.1,2278.1,489.4,2278,489.8z M2435.3,488.2c-0.1-0.3-0.2-0.6-0.3-0.9l1-0.3 c0.1,0.3,0.2,0.6,0.3,1L2435.3,488.2z M2278.9,487l-0.9-0.4c0.1-0.3,0.3-0.6,0.4-0.9l0.9,0.4 C2279.1,486.4,2279,486.7,2278.9,487z M2434.4,485.3c-0.1-0.3-0.2-0.6-0.3-0.9l0.9-0.4c0.1,0.3,0.2,0.6,0.3,0.9L2434.4,485.3z  M2280.2,484.3l-0.9-0.5c0.2-0.3,0.4-0.6,0.5-0.9l0.8,0.5C2280.5,483.8,2280.3,484,2280.2,484.3z M2433.3,482.6 c-0.1-0.3-0.3-0.6-0.4-0.9l0.9-0.4c0.1,0.3,0.3,0.6,0.4,0.9L2433.3,482.6z M2281.8,481.9l-0.8-0.6c0.2-0.3,0.4-0.5,0.7-0.8 l0.8,0.7C2282.2,481.4,2282,481.6,2281.8,481.9z M2432.1,479.9c-0.2-0.3-0.3-0.6-0.5-0.9l0.9-0.5c0.2,0.3,0.3,0.6,0.5,0.9 L2432.1,479.9z M2283.8,479.7l-0.7-0.7c0.5-0.5,0.8-0.7,0.8-0.7l0.6,0.8C2284.5,479.1,2284.2,479.3,2283.8,479.7z M2430.6,477.4 L2430.6,477.4l0.8-0.7l0.1,0.1L2430.6,477.4z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1651"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M2328.9,541.7l0-1c0.3,0,0.7,0,1,0l0,1C2329.6,541.7,2329.2,541.7,2328.9,541.7z M2326.9,541.7 c-0.3,0-0.7,0-1,0l0-1c0.3,0,0.7,0,1,0L2326.9,541.7z M2331.9,541.6l0-1c0.3,0,0.7,0,1,0l0,1 C2332.6,541.6,2332.3,541.6,2331.9,541.6z M2323.9,541.6c-0.3,0-0.7,0-1-0.1l0.1-1c0.3,0,0.7,0,1,0.1L2323.9,541.6z  M2334.9,541.5l-0.1-1c0.3,0,0.7,0,1-0.1l0.1,1C2335.6,541.4,2335.3,541.4,2334.9,541.5z M2320.9,541.4c-0.3,0-0.7-0.1-1-0.1 l0.1-1c0.3,0,0.7,0.1,1,0.1L2320.9,541.4z M2337.9,541.2l-0.1-1l1-0.1l0.1,1L2337.9,541.2z M2317.9,541c-0.3,0-0.7-0.1-1-0.1 l0.1-1c0.3,0,0.7,0.1,1,0.1L2317.9,541z M2340.9,540.9l-0.1-1l1-0.1l0.1,1L2340.9,540.9z M2314.9,540.6c-0.3-0.1-0.7-0.1-1-0.2 l0.2-1c0.3,0.1,0.6,0.1,1,0.2L2314.9,540.6z M2343.9,540.5l-0.1-1l1-0.2l0.2,1L2343.9,540.5z M2346.9,540l-0.2-1l1-0.2l0.2,1 L2346.9,540z M2311.9,540c-0.3-0.1-0.7-0.2-1-0.2l0.2-1c0.3,0.1,0.6,0.2,1,0.2L2311.9,540z M2349.9,539.5l-0.2-1l1-0.2l0.2,1 L2349.9,539.5z M2309,539.2c-0.3-0.1-0.6-0.2-1-0.3l0.3-0.9c0.3,0.1,0.6,0.2,0.9,0.3L2309,539.2z M2352.8,538.8l-0.2-1l1-0.2 l0.2,1L2352.8,538.8z M2306.1,538.2c-0.3-0.1-0.6-0.2-0.9-0.4l0.4-0.9c0.3,0.1,0.6,0.2,0.9,0.4L2306.1,538.2z M2355.7,538.1 l-0.2-1l1-0.3l0.3,1L2355.7,538.1z M2358.6,537.3l-0.3-1l1-0.3l0.3,1L2358.6,537.3z M2303.3,537c-0.3-0.1-0.6-0.3-0.9-0.5 l0.5-0.9c0.3,0.2,0.6,0.3,0.9,0.4L2303.3,537z M2361.5,536.5l-0.3-1c0.3-0.1,0.6-0.2,0.9-0.3l0.3,0.9 C2362.2,536.3,2361.9,536.4,2361.5,536.5z M2364.4,535.5l-0.3-0.9c0.3-0.1,0.6-0.2,0.9-0.3l0.3,0.9 C2365,535.3,2364.7,535.4,2364.4,535.5z M2300.7,535.5c-0.3-0.2-0.6-0.4-0.9-0.6l0.6-0.8c0.3,0.2,0.5,0.4,0.8,0.5L2300.7,535.5z  M2367.2,534.5l-0.4-0.9c0.3-0.1,0.6-0.2,0.9-0.4l0.4,0.9C2367.8,534.2,2367.5,534.3,2367.2,534.5z M2298.2,533.7 c-0.3-0.2-0.5-0.4-0.8-0.7l0.7-0.7c0.2,0.2,0.5,0.4,0.7,0.6L2298.2,533.7z M2370,533.3l-0.4-0.9c0.3-0.1,0.6-0.3,0.9-0.4 l0.4,0.9C2370.6,533,2370.3,533.2,2370,533.3z M2372.8,532l-0.4-0.9c0.3-0.1,0.6-0.3,0.9-0.4l0.5,0.9 C2373.4,531.7,2373.1,531.9,2372.8,532z M2295.9,531.6c-0.2-0.3-0.5-0.5-0.7-0.8l0.8-0.6c0.2,0.2,0.4,0.5,0.6,0.7L2295.9,531.6z  M2375.4,530.6l-0.5-0.9c0.3-0.2,0.6-0.3,0.9-0.5l0.5,0.9C2376,530.3,2375.7,530.4,2375.4,530.6z M2294,529.2 c-0.2-0.3-0.4-0.6-0.6-0.8l0.8-0.5c0.2,0.3,0.4,0.5,0.5,0.8L2294,529.2z M2378,529l-0.5-0.8l0.8-0.5l0.5,0.8L2378,529z  M2380.5,527.4l-0.6-0.8l0.8-0.6l0.6,0.8L2380.5,527.4z M2292.4,526.6c-0.2-0.3-0.3-0.6-0.5-0.9l0.9-0.4 c0.1,0.3,0.3,0.6,0.4,0.9L2292.4,526.6z M2383,525.6l-0.6-0.8c0.3-0.2,0.5-0.4,0.8-0.6l0.6,0.8 C2383.5,525.2,2383.3,525.4,2383,525.6z M2291.2,523.8c-0.1-0.3-0.2-0.6-0.3-1l1-0.3c0.1,0.3,0.2,0.6,0.3,0.9L2291.2,523.8z  M2385.4,523.8l-0.6-0.8l0.8-0.6l0.6,0.8L2385.4,523.8z M2387.8,521.9l-0.6-0.8l0.8-0.6l0.6,0.8L2387.8,521.9z M2290.3,520.9 c-0.1-0.3-0.1-0.7-0.2-1l1-0.2c0,0.3,0.1,0.6,0.2,1L2290.3,520.9z M2390.1,520l-0.7-0.8l0.8-0.7l0.7,0.8L2390.1,520z  M2392.3,518l-0.7-0.7l0.7-0.7l0.7,0.7L2392.3,518z M2289.9,517.8c0-0.3,0-0.5,0-0.8l0-0.3l1,0l0,0.3c0,0.2,0,0.5,0,0.7 L2289.9,517.8z M2394.6,516l-0.7-0.7l0.7-0.7l0.7,0.7L2394.6,516z M2291,514.9l-1-0.2c0.1-0.7,0.2-1,0.2-1l1,0.3 C2291.2,514,2291.1,514.3,2291,514.9z M2396.7,513.9l-0.7-0.7l0.7-0.7l0.7,0.7L2396.7,513.9z M2398.9,511.8l-0.7-0.7l0.7-0.7 l0.7,0.7L2398.9,511.8z M2400.9,509.6l-0.7-0.7l0.7-0.7l0.7,0.7L2400.9,509.6z M2403,507.4l-0.7-0.7c0.2-0.2,0.4-0.5,0.7-0.7 l0.8,0.7C2403.4,506.9,2403.2,507.1,2403,507.4z M2404.9,505.1l-0.8-0.6l0.6-0.8l0.8,0.6L2404.9,505.1z M2406.9,502.8l-0.8-0.6 c0.2-0.3,0.4-0.5,0.6-0.8l0.8,0.6C2407.3,502.3,2407.1,502.5,2406.9,502.8z M2408.7,500.4l-0.8-0.6c0.2-0.3,0.4-0.5,0.6-0.8 l0.8,0.6C2409.1,499.9,2408.9,500.1,2408.7,500.4z M2410.6,498l-0.8-0.6l0.6-0.8l0.8,0.6L2410.6,498z M2412.3,495.5l-0.8-0.6 l0.6-0.8l0.8,0.6L2412.3,495.5z M2414,493.1l-0.8-0.5l0.5-0.8l0.8,0.5L2414,493.1z M2415.6,490.5l-0.8-0.5l0.5-0.8l0.9,0.5 L2415.6,490.5z M2417.2,487.9l-0.9-0.5l0.5-0.9l0.9,0.5L2417.2,487.9z M2418.6,485.3l-0.9-0.5c0.2-0.3,0.3-0.6,0.5-0.9l0.9,0.5 C2419,484.7,2418.8,485,2418.6,485.3z M2420,482.6l-0.9-0.4c0.1-0.3,0.3-0.6,0.4-0.9l0.9,0.4 C2420.3,482,2420.2,482.3,2420,482.6z M2421.3,479.9l-0.9-0.4c0.1-0.3,0.3-0.6,0.4-0.9l0.9,0.4 C2421.6,479.3,2421.5,479.6,2421.3,479.9z M2422.5,477.1l-0.9-0.4c0.1-0.3,0.2-0.6,0.4-0.9l0.9,0.4 C2422.8,476.5,2422.6,476.8,2422.5,477.1z M2423.6,474.3l-0.9-0.3c0.1-0.3,0.2-0.6,0.3-0.9l0.9,0.3 C2423.8,473.6,2423.7,474,2423.6,474.3z M2424.5,471.4l-1-0.3c0.1-0.3,0.2-0.6,0.3-1l1,0.3 C2424.7,470.8,2424.6,471.1,2424.5,471.4z M2425.3,468.5l-1-0.2c0.1-0.3,0.2-0.6,0.2-1l1,0.2 C2425.5,467.8,2425.4,468.2,2425.3,468.5z M2426,465.5l-1-0.2c0.1-0.3,0.1-0.7,0.2-1l1,0.2C2426.1,464.9,2426,465.2,2426,465.5z  M2426.4,462.5l-1-0.1c0-0.3,0.1-0.7,0.1-1l1,0.1C2426.5,461.9,2426.5,462.2,2426.4,462.5z M2426.7,459.5l-1-0.1 c0-0.3,0-0.7,0-1l1,0C2426.7,458.8,2426.7,459.2,2426.7,459.5z M2425.7,456.5c0-0.3,0-0.7,0-1l1-0.1c0,0.3,0,0.7,0,1 L2425.7,456.5z M2425.5,453.6c0-0.3-0.1-0.7-0.1-1l1-0.1c0,0.3,0.1,0.7,0.1,1L2425.5,453.6z M2425.1,450.6 c-0.1-0.3-0.1-0.6-0.2-1l1-0.2c0.1,0.3,0.2,0.7,0.2,1L2425.1,450.6z M2424.4,447.8c-0.1-0.3-0.2-0.5-0.3-0.8l-0.1-0.2l1-0.3 l0,0.1c0.1,0.3,0.2,0.5,0.3,0.8L2424.4,447.8z M2423.4,445c-0.1-0.3-0.3-0.6-0.4-0.9l0.9-0.4c0.1,0.3,0.3,0.6,0.4,0.9 L2423.4,445z M2422.1,442.3c-0.2-0.3-0.3-0.6-0.5-0.9l0.9-0.5c0.2,0.3,0.3,0.6,0.5,0.9L2422.1,442.3z M2420.6,439.8 c-0.2-0.3-0.4-0.6-0.5-0.8l0.8-0.6c0.2,0.3,0.4,0.6,0.6,0.8L2420.6,439.8z M2418.9,437.4c-0.2-0.3-0.4-0.5-0.6-0.8l0.8-0.6 c0.2,0.3,0.4,0.5,0.6,0.8L2418.9,437.4z M2417,435.1c-0.2-0.2-0.5-0.5-0.7-0.7l0.7-0.7c0.2,0.2,0.5,0.5,0.7,0.7L2417,435.1z  M2414.9,433.1c-0.2-0.2-0.5-0.4-0.7-0.6l0.6-0.8c0.3,0.2,0.5,0.4,0.8,0.7L2414.9,433.1z M2412.6,431.2 c-0.3-0.2-0.5-0.4-0.8-0.6l0.6-0.8c0.3,0.2,0.5,0.4,0.8,0.6L2412.6,431.2z M2410.2,429.5c-0.3-0.2-0.6-0.4-0.8-0.5l0.5-0.9 c0.3,0.2,0.6,0.3,0.9,0.5L2410.2,429.5z M2407.6,428c-0.3-0.2-0.6-0.3-0.9-0.4l0.4-0.9c0.3,0.1,0.6,0.3,0.9,0.5L2407.6,428z  M2404.9,426.7l-0.1,0l0.2-0.5v-0.5c0.1,0,0.1,0,0.3,0.1L2404.9,426.7l0.1-0.2L2404.9,426.7z"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Path_1640"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M510.8,274.1c0.1-0.9,0.2-1.8,0.2-2.7c0-11.1-8.1-20.1-18.2-20.1c-7.5,0-14,5.1-16.8,12.3 c-2.2-2.3-5.3-3.5-8.4-3.6c-7,0-12.7,6.3-12.7,14.1h-2.4c-6.7,0-12.3,6.1-12.3,13.6l0,0c0,7.5,5.5,13.6,12.3,13.6h57.4 c6.7,0,12.3-6.1,12.3-13.6l0,0C522.2,280.5,517.1,274.7,510.8,274.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M509.9,301.8h-57.4c-7,0-12.8-6.3-12.8-14.1c0-7.8,5.7-14.1,12.8-14.1h1.9c0.2-7.8,6.1-14.1,13.2-14.1 c3.1,0,6,1.2,8.2,3.2c3.1-7.3,9.6-11.9,16.9-11.9c10.3,0,18.7,9.3,18.7,20.6c0,0.8,0,1.5-0.1,2.3c6.4,0.8,11.3,6.8,11.3,14 C522.7,295.4,516.9,301.8,509.9,301.8z M452.5,274.6c-6.5,0-11.8,5.9-11.8,13.1c0,7.2,5.3,13.1,11.8,13.1h57.4 c6.5,0,11.8-5.9,11.8-13.1c0-6.8-4.8-12.5-10.9-13l-0.5,0l0.1-0.5c0.1-0.9,0.2-1.8,0.2-2.7c0-10.8-7.9-19.6-17.7-19.6 c-7.1,0-13.5,4.7-16.3,12l-0.3,0.7l-0.5-0.6c-2.1-2.2-5-3.4-8.1-3.4c-6.7,0-12.2,6.1-12.2,13.6v0.5H452.5z"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1865"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1857",
    transform: "translate(-146.301 34.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M533.8,370h-59l0,0v-53.8c0-3.3,2.7-6.1,6.1-6.1h46.8c3.3,0,6.1,2.7,6.1,6.1V370L533.8,370z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M533.8,370.4h-59c-0.2,0-0.4-0.2-0.4-0.4v-53.8c0-3.6,2.9-6.5,6.5-6.5h46.8c3.6,0,6.5,2.9,6.5,6.5V370 C534.2,370.2,534,370.4,533.8,370.4z M475.3,369.6h58.2v-53.4c0-3.1-2.5-5.7-5.7-5.7h-46.8c-3.1,0-5.7,2.5-5.7,5.7V369.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1643"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M533.8,317.9h-59v-1.8c0-3.3,2.7-6.1,6.1-6.1h46.8c3.3,0,6.1,2.7,6.1,6.1V317.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M534.2,318.3h-59.8v-2.2c0-3.6,2.9-6.5,6.5-6.5h46.8c3.6,0,6.5,2.9,6.5,6.5V318.3z M475.3,317.5h58.2 v-1.4c0-3.1-2.5-5.7-5.7-5.7h-46.8c-3.1,0-5.7,2.5-5.7,5.7V317.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.7,
    y: 324.3,
    className: "st0",
    width: 7.3,
    height: 15.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M529,339.9h-7.3c-0.3,0-0.5-0.2-0.5-0.5v-15.1c0-0.3,0.2-0.5,0.5-0.5h7.3c0.3,0,0.5,0.2,0.5,0.5v15.1 C529.5,339.7,529.3,339.9,529,339.9z M522.2,338.9h6.3v-14.1h-6.3V338.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_441"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.5,
    y: 338.6,
    className: "st0",
    width: 35.5,
    height: 15.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M515,354.3h-35.5c-0.3,0-0.5-0.2-0.5-0.5v-15.1c0-0.3,0.2-0.5,0.5-0.5H515c0.3,0,0.5,0.2,0.5,0.5v15.1 C515.5,354,515.3,354.3,515,354.3z M480,353.3h34.5v-14.1H480V353.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.7,
    y: 345,
    className: "st0",
    width: 7.3,
    height: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M529,347.6h-7.3c-0.3,0-0.5-0.2-0.5-0.5V345c0-0.3,0.2-0.5,0.5-0.5h7.3c0.3,0,0.5,0.2,0.5,0.5v2.1 C529.5,347.4,529.3,347.6,529,347.6z M522.2,346.6h6.3v-1.1h-6.3V346.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_21"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.7,
    y: 352.7,
    className: "st0",
    width: 7.3,
    height: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M529,355.3h-7.3c-0.3,0-0.5-0.2-0.5-0.5v-2.1c0-0.3,0.2-0.5,0.5-0.5h7.3c0.3,0,0.5,0.2,0.5,0.5v2.1 C529.5,355.1,529.3,355.3,529,355.3z M522.2,354.3h6.3v-1.1h-6.3V354.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_22"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.7,
    y: 360.3,
    className: "st0",
    width: 7.3,
    height: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M529,362.9h-7.3c-0.3,0-0.5-0.2-0.5-0.5v-2.1c0-0.3,0.2-0.5,0.5-0.5h7.3c0.3,0,0.5,0.2,0.5,0.5v2.1 C529.5,362.7,529.3,362.9,529,362.9z M522.2,361.9h6.3v-1.1h-6.3V361.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    transform: "translate(474.236 353.814)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M30.3,3.6h-25C5,3.6,4.8,3.4,4.8,3.1S5,2.6,5.3,2.6h25c0.3,0,0.5,0.2,0.5,0.5S30.6,3.6,30.3,3.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40.8,3.6H32c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h8.8c0.3,0,0.5,0.2,0.5,0.5S41,3.6,40.8,3.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.9,7H5.3C5,7,4.8,6.7,4.8,6.5S5,6,5.3,6h7.7c0.3,0,0.5,0.2,0.5,0.5S13.2,7,12.9,7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M32.7,7H15.2c-0.3,0-0.5-0.2-0.5-0.5S14.9,6,15.2,6h17.5c0.3,0,0.5,0.2,0.5,0.5S33,7,32.7,7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40.8,7h-6.2c-0.3,0-0.5-0.2-0.5-0.5S34.3,6,34.6,6h6.2c0.3,0,0.5,0.2,0.5,0.5S41,7,40.8,7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.1,10.3H5.3c-0.3,0-0.5-0.2-0.5-0.5S5,9.3,5.3,9.3h6.8c0.3,0,0.5,0.2,0.5,0.5S12.4,10.3,12.1,10.3z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1860",
    transform: "translate(474.236 321.174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Line_22-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M30.3,3.6h-25C5,3.6,4.8,3.4,4.8,3.1S5,2.6,5.3,2.6h25c0.3,0,0.5,0.2,0.5,0.5S30.6,3.6,30.3,3.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_23-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40.8,3.6H32c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h8.8c0.3,0,0.5,0.2,0.5,0.5S41,3.6,40.8,3.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_24-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.9,7H5.3C5,7,4.8,6.7,4.8,6.5S5,6,5.3,6h7.7c0.3,0,0.5,0.2,0.5,0.5S13.2,7,12.9,7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_25-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M32.7,7H15.2c-0.3,0-0.5-0.2-0.5-0.5S14.9,6,15.2,6h17.5c0.3,0,0.5,0.2,0.5,0.5S33,7,32.7,7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_26-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40.8,7h-6.2c-0.3,0-0.5-0.2-0.5-0.5S34.3,6,34.6,6h6.2c0.3,0,0.5,0.2,0.5,0.5S41,7,40.8,7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M24.5,10.3H5.3c-0.3,0-0.5-0.2-0.5-0.5S5,9.3,5.3,9.3h19.2c0.3,0,0.5,0.2,0.5,0.5S24.8,10.3,24.5,10.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40.8,10.3H26.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h14.2c0.3,0,0.5,0.2,0.5,0.5S41,10.3,40.8,10.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_29-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M12.1,13.6H5.3c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h6.8c0.3,0,0.5,0.2,0.5,0.5S12.4,13.6,12.1,13.6z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M36.3,13.6H13.8c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h22.5c0.3,0,0.5,0.2,0.5,0.5S36.5,13.6,36.3,13.6 z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Line_31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40.8,13.6h-2.6c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2.6c0.3,0,0.5,0.2,0.5,0.5S41,13.6,40.8,13.6z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1858",
    transform: "translate(177.023 206.574)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1314"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M156.7,142c0,0.5-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8l0,0 C156.3,141.2,156.7,141.6,156.7,142z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1315"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M159.9,142c0,0.5-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8l0,0 C159.6,141.2,159.9,141.6,159.9,142z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1316"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M163.2,142c0,0.5-0.4,0.8-0.8,0.8s-0.8-0.4-0.8-0.8c0-0.5,0.4-0.8,0.8-0.8l0,0 C162.8,141.2,163.2,141.6,163.2,142z"
  }))))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Path_1641"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M414.6,401.1c0.1-0.5,0.1-1,0.1-1.5c0-6.2-4.6-11.1-10.2-11.1c-4.2,0.1-8,2.8-9.4,6.8c-1.3-1.3-3-2-4.7-2 c-3.9,0-7.1,3.5-7.1,7.8H382c-3.8,0-6.9,3.4-6.9,7.5l0,0c0,4.1,3.1,7.5,6.9,7.5h32.2c3.8,0,6.9-3.4,6.9-7.5l0,0 C421.1,404.8,418.4,401.5,414.6,401.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M414.1,416.6H382c-4.1,0-7.4-3.6-7.4-8c0-4.4,3.3-8,7.4-8h0.8c0.2-4.3,3.6-7.8,7.6-7.8 c1.7,0,3.3,0.6,4.5,1.6c1.7-3.8,5.4-6.4,9.6-6.5c5.9,0,10.7,5.2,10.7,11.6c0,0.4,0,0.7-0.1,1.1c3.8,0.7,6.5,4,6.3,7.9 C421.5,413,418.2,416.6,414.1,416.6z M382,401.5c-3.5,0-6.4,3.1-6.4,7c0,3.9,2.9,7,6.4,7h32.2c3.5,0,6.4-3.1,6.4-7 c0.1-3.5-2.4-6.5-5.9-7l-0.5-0.1l0.1-0.5c0.1-0.5,0.1-1,0.1-1.4c0-5.9-4.4-10.6-9.7-10.6c-4,0.1-7.6,2.7-8.9,6.5l-0.3,0.7 l-0.6-0.6c-1.2-1.2-2.7-1.8-4.4-1.8c-3.7,0-6.6,3.3-6.6,7.3v0.5H382z"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1862",
    transform: "translate(484.94 339.433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1334",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1333"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_220"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M11.3,3.1H44c3.3,0,6,2.7,6,6v29.7c0,3.3-2.7,6-6,6H11.3c-3.3,0-6-2.7-6-6V9.1C5.3,5.8,8,3.1,11.3,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M44,45.3H11.3c-3.6,0-6.5-2.9-6.5-6.5V9.1c0-3.6,2.9-6.5,6.5-6.5H44c3.6,0,6.5,2.9,6.5,6.5v29.7 C50.5,42.3,47.5,45.3,44,45.3z M11.3,3.6c-3,0-5.5,2.5-5.5,5.5v29.7c0,3,2.5,5.5,5.5,5.5H44c3,0,5.5-2.5,5.5-5.5V9.1 c0-3-2.5-5.5-5.5-5.5H11.3z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_221"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M44,45.3H11.3c-3.6,0-6.5-2.9-6.5-6.5V9.1c0-3.6,2.9-6.5,6.5-6.5H44c3.6,0,6.5,2.9,6.5,6.5v29.7 C50.5,42.3,47.5,45.3,44,45.3z M11.3,3.6c-3,0-5.5,2.5-5.5,5.5v29.7c0,3,2.5,5.5,5.5,5.5H44c3,0,5.5-2.5,5.5-5.5V9.1 c0-3-2.5-5.5-5.5-5.5H11.3z"
  })))))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1863",
    transform: "translate(336.126 260.448)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1344",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1343"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1342"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_223"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11,3.1h41c3.2,0,5.7,2.6,5.7,5.7v34.9c0,3.2-2.6,5.7-5.7,5.7H11c-3.2,0-5.7-2.6-5.7-5.7V8.8 C5.3,5.7,7.8,3.1,11,3.1z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_224"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M11,3.1h41c3.2,0,5.7,2.6,5.7,5.7v34.9c0,3.2-2.6,5.7-5.7,5.7H11c-3.2,0-5.7-2.6-5.7-5.7V8.8 C5.3,5.7,7.8,3.1,11,3.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M52,50H11c-3.4,0-6.2-2.8-6.2-6.2V8.8c0-3.4,2.8-6.2,6.2-6.2h41c3.4,0,6.2,2.8,6.2,6.2v34.9 C58.2,47.2,55.4,50,52,50z M11,3.6C8.1,3.6,5.8,6,5.8,8.8v34.9c0,2.9,2.3,5.2,5.2,5.2h41c2.9,0,5.2-2.3,5.2-5.2V8.8 c0-2.9-2.3-5.2-5.2-5.2H11z"
  }))))))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Group_1861",
    transform: "translate(-998.235 400.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1645"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M1519.5-43.9C1519.5-43.9,1519.5-43.9,1519.5-43.9l-1.3-4.7c0,0,0-0.1-0.1-0.1c0,0-0.1,0-0.1,0l-0.9,0.9 l-0.1-0.1c-2.1-1.5-4.7-2.2-7.3-2.2c-7,0.1-12.6,5.8-12.5,12.8c0.1,7,5.8,12.6,12.8,12.5c3.3,0,6.5-1.4,8.8-3.7 c2.4-2.3,3.7-5.5,3.7-8.8l0,0c0,0,0-0.1,0-0.1l0,0c0,0,0,0-0.1-0.1l-1.8,0c0,0-0.1,0.1-0.1,0.1c0,2.8-1.1,5.5-3.1,7.4 c-2,2-4.6,3.1-7.4,3.2c-5.9,0.1-10.7-4.7-10.8-10.5c-0.1-5.9,4.7-10.7,10.6-10.8c2,0,4.1,0.5,5.8,1.6l0.1,0.1l-1.1,1.1 c0,0,0,0.1,0,0.1c0,0,0,0.1,0.1,0.1l4.7,1.2C1519.4-43.8,1519.4-43.8,1519.5-43.9C1519.5-43.9,1519.5-43.9,1519.5-43.9 L1519.5-43.9z M1496.9-37.2c-0.1-7.2,5.7-13,12.8-13.1c2.6,0,5.2,0.7,7.4,2.2l0.7-0.7c0.1-0.1,0.2-0.1,0.4-0.1 c0.1,0,0.2,0.1,0.3,0.3l1.3,4.7c0,0.1,0,0.3-0.1,0.4c-0.1,0.1-0.2,0.1-0.4,0.1l-4.7-1.2c-0.1,0-0.2-0.1-0.3-0.3 c0-0.1,0-0.3,0.1-0.4l0.8-0.8c-1.7-1-3.6-1.5-5.5-1.5c-5.7,0.1-10.3,4.8-10.3,10.5c0.1,5.7,4.8,10.3,10.5,10.3 c2.7,0,5.3-1.1,7.2-3.1c1.9-1.9,3-4.5,3-7.2c0-0.2,0.2-0.4,0.4-0.4l1.8,0c0.1,0,0.2,0.1,0.3,0.1l0,0c0.1,0.1,0.1,0.2,0.1,0.3 c0,3.4-1.4,6.6-3.8,9c-2.4,2.4-5.6,3.8-9,3.8C1502.9-24.3,1497-30,1496.9-37.2L1496.9-37.2z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1646"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1505.9-34.8h-3.7v-0.8l1.3-1.4c0.4-0.4,0.7-0.7,0.8-0.8c0.1-0.1,0.2-0.3,0.3-0.4c0.1-0.1,0.1-0.3,0.1-0.4 c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4,0-0.6,0.1c-0.2,0.1-0.4,0.2-0.6,0.4l-0.6-0.7 c0.2-0.2,0.4-0.3,0.7-0.5c0.2-0.1,0.4-0.2,0.6-0.2c0.2-0.1,0.5-0.1,0.7-0.1c0.3,0,0.6,0.1,0.9,0.2c0.2,0.1,0.5,0.3,0.6,0.5 c0.1,0.2,0.2,0.5,0.2,0.8c0,0.2,0,0.5-0.1,0.7c-0.1,0.2-0.2,0.5-0.4,0.7c-0.3,0.3-0.6,0.7-1,1l-0.7,0.6v0.1h2.3L1505.9-34.8 L1505.9-34.8z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1647"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1508.6-36.8v-0.9c0-0.2,0-0.4,0-0.7c0-0.3,0-0.5,0-0.5h0c-0.1,0.2-0.2,0.4-0.3,0.6l-1,1.5L1508.6-36.8z  M1510.3-35.9h-0.6v1.1h-1.1v-1.1h-2.3v-0.8l2.3-3.5h1v3.4h0.6L1510.3-35.9L1510.3-35.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1648"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1513.5-40.1l-2,5.3h-1l2-5.3H1513.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1649"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M1514.3-34.8l2-4.4h-2.6v-1h3.8v0.7l-2,4.6L1514.3-34.8z"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Path_1652"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M505.1,381c0-0.3,0.1-0.7,0.1-1c0-4-3-7.3-6.7-7.3c-2.8,0.1-5.2,1.8-6.1,4.4c-0.8-0.8-1.9-1.3-3.1-1.3 c-2.7,0.1-4.8,2.4-4.7,5.1h-0.9c-2.6,0.1-4.6,2.3-4.5,4.9l0,0c-0.1,2.6,1.9,4.8,4.5,4.9h21c2.6-0.1,4.6-2.3,4.5-4.9l0,0 C509.4,383.4,507.6,381.3,505.1,381z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M483.8,391.3c-2.9-0.1-5.1-2.6-5-5.4c-0.1-2.8,2.1-5.2,5-5.4h0.4c0.1-2.7,2.3-5,5.1-5.1c1.1,0,2.1,0.3,2.9,1 c1.1-2.4,3.6-4,6.3-4.1c4,0,7.2,3.5,7.2,7.8c0,0.2,0,0.4,0,0.6c2.5,0.5,4.2,2.7,4.1,5.3c0.1,2.8-2.1,5.2-5,5.4L483.8,391.3z  M483.8,381.5c-2.3,0.1-4.1,2.1-4,4.4c-0.1,2.3,1.7,4.3,4,4.4l21,0c2.3-0.1,4.1-2.1,4-4.4c0.1-2.3-1.5-4.1-3.7-4.4l-0.5-0.1 l0.1-0.5c0-0.3,0.1-0.6,0.1-0.9c0-3.7-2.8-6.8-6.2-6.8c-2.5,0.1-4.8,1.7-5.7,4.1l-0.3,0.7l-0.6-0.6c-0.7-0.7-1.7-1.1-2.7-1.1 c-2.4,0.1-4.2,2.2-4.1,4.6l0,0.5H483.8z"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Path_1305"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M349.5,286.2l9.4,10.8l10.7-16.6l6.6,8.6l1.6-2.5l10.9,13l-41.7,0L349.5,286.2z"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Path_1306"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.8,286.9l-4.4,9.3l-13.9-22.1l-6.5,14l-2.1-3.3l-6.9,14.7l41.7,0L380.8,286.9z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingSync);
export default __webpack_public_path__ + "static/media/landing-sync.17e7276530612ed3372d8c4fcb466b50.svg";
export { ForwardRef as ReactComponent };